import { Box, Typography, useTheme } from "@mui/material";

interface FoodGroupHeaderProps {
  promotedOrAvoided: "promoted" | "avoided";
  foodGroupName: string;
}

export const FoodGroupHeader = ({ foodGroupName, promotedOrAvoided }: FoodGroupHeaderProps) => {
  const { palette } = useTheme();
  const promoteOrAvoidText = promotedOrAvoided === "promoted" ?
      "These foods should be included in your diet."
    :
      "These foods should be avoided!";
  return (
    <Box sx={{ pb: 1 }}>
      <Box>
        <Typography variant="body1Semibold" color={promotedOrAvoided === "promoted" ? palette.success.dark : palette.error.dark }>
          {foodGroupName}
        </Typography>
      </Box>
      <Box sx={{ pt: 2, pl: 1 }}>
        <Box sx={{
          lineHeight: 0.65,
          fontStyle: "italic",
          borderLeft: `1px solid ${palette.grey[300]}`,
          pl: 1,
        }}>
          <Box  sx={{ lineHeight: 0.8, fontSize: 10, color: palette.grey[600] }}>
            <Typography variant="subtitle1" sx={{ lineHeight: 0.8, fontSize: 10, color: palette.grey[600] }}>
              {promoteOrAvoidText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
